import { setRoles } from 'src/reducers/routing/utils'

import { activeProjectsVar } from './active-projects'
import { routingVar, INITIAL_ROUTING_DATA, TRoutingVarType } from './routing'
import { savedFiltersVar, SavedFilter } from './saved-filters'
import { userVar } from './user'

export const resetStore = () => {
  routingVar({
    ...INITIAL_ROUTING_DATA,
    init: true,
    roles: ['non-authenticated'],
  })
  userVar(null)
  activeProjectsVar([])
  savedFiltersVar(null)
}

export const setUserEmail = (email: string) => {
  const user: $TSFixMe = userVar()
  userVar({ ...user, email })
}

export const setRouting = (data: Partial<TRoutingVarType>) => {
  routingVar({ ...routingVar(), ...data })
}

export const setUser = (user: $TSFixMe) => {
  const savedActiveProjects = user.activeProjectsIds
  const activeProjects =
    savedActiveProjects?.length && user.activeProjects
      ? user.activeProjects.edges.map(({ node }: $TSFixMe) => node)
      : []

  userVar(user)
  activeProjectsVar(activeProjects)
  setRouting({
    roles: setRoles(user),
    init: true,
  })
}

export const setSavedFilters = (filters: SavedFilter[]) => {
  const groupedFilters = filters.reduce(
    (acc: Record<string, SavedFilter[]>, filter: SavedFilter) => {
      const { tableKey } = filter
      return {
        ...acc,
        [tableKey]: [...(acc[tableKey] || []), filter],
      }
    },
    {} as Record<string, SavedFilter[]>
  )

  savedFiltersVar(groupedFilters)
}

export const updateSavedFilter = (
  tableKey: string,
  id: string,
  newValue?: SavedFilter
) => {
  const currentFilters = savedFiltersVar() || {}
  const tableFilters = currentFilters[tableKey] || []

  if (newValue) {
    const itemIndex = tableFilters.findIndex((item) => item.id === id)
    if (itemIndex !== -1) {
      const updatedItems = [...tableFilters]
      updatedItems[itemIndex] = newValue
      savedFiltersVar({ ...currentFilters, [tableKey]: updatedItems })
    }
  } else {
    const updatedItems = tableFilters.filter((item) => item.id !== id)
    savedFiltersVar({ ...currentFilters, [tableKey]: updatedItems })
  }
}
